import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface FieldNoteProps {
  /** `attention` alleen als er iets vastloopt; `muted` voor een eis die nog niet overtreden is. */
  tone: 'muted' | 'attention'
  children: ReactNode
}

/**
 * Een kort label binnen de rechterkant van een leeg invoerveld. Het staat buiten de
 * layout-flow, dus een veld dat iets te melden heeft duwt niets opzij: in een dichte
 * tabel is dat het verschil tussen rust en een rij die op- en neerspringt terwijl je
 * typt. Alleen bruikbaar zolang het veld leeg is, anders loopt de invoer eronder door.
 *
 * Bewust geen `label-caps`: uppercase leest binnen een veld als een eenheid-achtervoegsel
 * en schreeuwt in de attentie-toon.
 */
export function FieldNote({ tone, children }: FieldNoteProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-y-0 right-3 flex items-center text-[11px] font-medium transition-colors duration-150',
        tone === 'attention' ? 'text-status-overdue' : 'text-ink-faint',
      )}
    >
      {children}
    </span>
  )
}
